
import CollectionsBookmark from '@material-ui/icons/CollectionsBookmark';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { useEffect, useState } from 'react';
import { AutocompleteInput, Button, DateField, DateInput, Identifier, ListProps, ReferenceField, ReferenceInput, required, SelectInput, TextField, TextInput, useAuthProvider, useDataProvider, useNotify, useTranslate, useRefresh } from "react-admin";
import { DialogForm, DialogGrid, DialogList, GeometriesField, GeometryImportButton, Row, TranslateField } from '../common/components';
import { tracking } from '../common/components/utils/choice';
import { filterObject, filterValue } from '../common/components/utils/fn';
import { startLot, validateLot } from '../services/lot/actions';
import { ProductionUnitList } from "./ProductionUnit";
import { DialogListProps } from '../common/components/dialog/DialogList';


export const LotIcon = CollectionsBookmark;

export interface LotProps extends ListProps {
    projectId?: Identifier;
    projectStatus: string;
    hasMap?: boolean;
};



const StartButton = (props) => {
    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const notify = useNotify();
    const refresh = useRefresh();
    return <Button style={{ display: (props && props.record && props.record.tracking === "waiting") ? "inline-flex" : "none" }} onClick={startLot(dataProvider, refresh, translate, notify, props.record)} label="resources.start" className="activate" variant="contained"><PlayArrowIcon /></Button>
};

export const LotList = (propsReceive: LotProps) => {
    const { projectId, projectStatus, hasMap, ...propsOthers } = propsReceive;
    const authProvider = useAuthProvider();
    const [security, setSecurity] = useState(null);
    useEffect(() => {
        const id = authProvider.getId();
        const role = authProvider.getRole();
        if (role === "projectManager") {
            setSecurity({
                _or: filterValue([
                    filterObject("project.ownerId._eq", id),
                    filterObject("project.project_delegates.userId._eq", id)
                ])
            });
        }
    }, [authProvider]);
    const title = projectId ? " " : propsOthers.title;
    const filterDefaultValues = projectId ? { ...propsOthers.filterDefaultValues, projectId } : propsOthers.filterDefaultValues;
    const props = {
        ...propsOthers,
        resource: "lot",
        title,
        filterDefaultValues
    } as DialogListProps;
    if (hasMap) {
        props.buttons = [
            <GeometryImportButton projectId={projectId} />
        ];
    }
    return <DialogList {...props} filter={security} create={projectStatus !== "disabled"} bulkActionButtons={false} dialog={
        <DialogForm initialValues={{ projectId, tracking: "waiting" }} validate={validateLot}>
            <TextInput source="name" validate={required()} />
            <Row>
                <DateInput source="startDate" validate={required()} />
                <DateInput source="endDate" validate={required()} />
            </Row>
            <SelectInput disabled source="tracking" choices={tracking} />
            {projectId === undefined && <ReferenceInput source="projectId" reference="project" validate={required()}>
                <AutocompleteInput />
            </ReferenceInput>}
        </DialogForm>
    }>
        <DialogGrid rowClick="expand" expand={({ id }) => <ProductionUnitList hasMap={hasMap} key={id} lotId={id} />} isEdit={(record) => {
            return (record && record.tracking === "waiting") || null;
        }}>
            <TextField source="name" />
            <DateField source="startDate" />
            <DateField source="endDate" />
            {projectId === undefined && <ReferenceField source="projectId" reference="project">
                <TextField source="name" />
            </ReferenceField>}
            {hasMap && <GeometriesField source="geometry"  />}
            <TranslateField source="tracking" />
            <StartButton />
        </DialogGrid>
    </DialogList>

}